import React, { memo } from 'react';
import styles from './TablePreview.module.scss';
import { useSelector } from 'react-redux';

const TablePreview = memo(() => {
  const { excelPreviewData, excelPreviewColumns, highlightedRows } =
    useSelector((state) => state.rsoImportStore);

  return (
    <div className={styles.container}>
      {excelPreviewData.length > 0 && (
        <div className={styles.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>№</th>
                {excelPreviewColumns.map((col, idx) => (
                  <th key={idx}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {excelPreviewData.map((row, rowIdx) => {
                const highlight = highlightedRows.find(
                  (item) => item.rows === rowIdx + 1
                );
                return (
                  <tr
                    key={rowIdx}
                    style={{
                      backgroundColor: highlight
                        ? highlight.color
                        : 'transparent',
                    }}
                  >
                    <td>{rowIdx + 1}</td>
                    {excelPreviewColumns.map((_, colIdx) => (
                      <td key={colIdx}>
                        {row[colIdx] instanceof Date
                          ? row[colIdx].toLocaleString()
                          : String(row[colIdx] ?? '')}{' '}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
});

export default TablePreview;
